export default __webpack_public_path__ + "static/media/b1.0f387b8b.jpeg";